import React, { useState, useMemo, useCallback } from "react";
import { Switch } from "antd";
import { FiChevronUp } from "react-icons/fi";
import { PermissionGroupCardProps } from "./types";
import styles from "./styles.module.scss";

const PermissionGroupCard = React.memo(function PermissionGroupCard({
  title,
  permissions,
  selectedIds,
  onChange,
  onSelectAll,
  onDeselectAll,
  containerClassName,
  disabled,
}: PermissionGroupCardProps) {
  const [isExpanded, setIsExpanded] = useState(true);

  const enabledCount = useMemo(
    () => permissions.filter((p) => selectedIds.includes(p.id)).length,
    [permissions, selectedIds]
  );
  const totalCount = permissions.length;
  const isAllSelected = enabledCount === totalCount && totalCount > 0;

  const handleSelectAllClick = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      if (isAllSelected) {
        onDeselectAll();
      } else {
        onSelectAll();
      }
    },
    [isAllSelected, onDeselectAll, onSelectAll]
  );

  return (
    <div className={`${styles.container} ${containerClassName || ""}`}>
      <div
        className={styles.header}
        onClick={() => setIsExpanded((prev) => !prev)}
      >
        <div className={styles.headerLeft}>
          <p className={styles.title}>{title}</p>
          <p className={styles.subtitle}>
            {`${enabledCount} of ${totalCount} permissions enabled`}
          </p>
        </div>
        <div className={styles.headerRight}>
          {!disabled && (
            <button
              type="button"
              className={styles.selectAllBtn}
              onClick={handleSelectAllClick}
            >
              {isAllSelected ? "Deselect All" : "Select All"}
            </button>
          )}
          <div
            className={`${styles.iconWrapper} ${!isExpanded ? styles.collapsed : ""
              }`}
          >
            <FiChevronUp />
          </div>
        </div>
      </div>

      <div
        className={styles.contentWrapper}
        style={{ gridTemplateRows: isExpanded ? "1fr" : "0fr" }}
      >
        <div className={styles.contentInner}>
          <div className={styles.content}>
            {permissions.map((item) => (
              <div key={item.id} className={styles.row}>
                <span className={styles.rowLabel}>{item.name}</span>
                <Switch
                  className={styles.switch}
                  checked={selectedIds.includes(item.id)}
                  onChange={(checked) => onChange(item.id, checked)}
                  disabled={disabled}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
});

export default PermissionGroupCard;
